
import React from 'react';
import { Outlet } from 'react-router-dom';
import PressSidebar from '@/components/press/PressSidebar';

const PressDashboardLayout: React.FC = () => {
  return (
    <div className="flex w-full bg-gray-50">
      <PressSidebar />
      <main className="flex-1 ml-64 p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default PressDashboardLayout;
